const TipsSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">💡 Mẹo Sử Dụng Hiệu Quả</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-lg border border-blue-200">
                    <h3 className="text-lg font-semibold text-blue-900 mb-3">🎯 Học tập hiệu quả</h3>
                    <ul className="text-slate-700 space-y-2 text-sm">
                        <li>✓ Đọc lý thuyết trước khi làm bài tập</li>
                        <li>✓ Sử dụng AI để giải đáp thắc mắc ngay</li>
                        <li>✓ Làm bài tập đều đặn hàng ngày</li>
                        <li>✓ Xem lại kết quả và học từ sai lầm</li>
                    </ul>
                </div>

                <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg border border-green-200">
                    <h3 className="text-lg font-semibold text-green-900 mb-3">⏰ Quản lý thời gian</h3>
                    <ul className="text-slate-700 space-y-2 text-sm">
                        <li>✓ Kiểm tra lịch học mỗi ngày</li>
                        <li>✓ Làm bài trước deadline 1-2 ngày</li>
                        <li>✓ Đặt nhắc nhở cho các sự kiện quan trọng</li>
                        <li>✓ Ưu tiên bài tập gần deadline</li>
                    </ul>
                </div>

                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-lg border border-purple-200">
                    <h3 className="text-lg font-semibold text-purple-900 mb-3">🤖 Tận dụng AI</h3>
                    <ul className="text-slate-700 space-y-2 text-sm">
                        <li>✓ Hỏi cách giải thay vì xin đáp án</li>
                        <li>✓ Yêu cầu giải thích chi tiết từng bước</li>
                        <li>✓ Upload ảnh bài toán nếu có đồ thị phức tạp</li>
                        <li>✓ Tạo phiên chat riêng cho mỗi chủ đề</li>
                    </ul>
                </div>

                <div className="bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-lg border border-orange-200">
                    <h3 className="text-lg font-semibold text-orange-900 mb-3">💰 Quản lý học phí</h3>
                    <ul className="text-slate-700 space-y-2 text-sm">
                        <li>✓ Thanh toán đúng hạn để tránh quá hạn</li>
                        <li>✓ Có thể trả một phần nếu chưa đủ tiền</li>
                        <li>✓ Kiểm tra trạng thái thanh toán thường xuyên</li>
                        <li>✓ Giữ lại ảnh chụp màn hình giao dịch</li>
                    </ul>
                </div>
            </div>

            <div className="bg-gradient-to-r from-yellow-50 to-orange-50 p-6 rounded-lg border border-yellow-200">
                <h3 className="text-lg font-semibold text-yellow-900 mb-3">⚡ Phím tắt hữu ích</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                    <div className="flex items-center gap-2">
                        <kbd className="px-2 py-1 bg-white rounded border border-slate-300 font-mono">Ctrl + K</kbd>
                        <span className="text-slate-700">Tìm kiếm nhanh</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <kbd className="px-2 py-1 bg-white rounded border border-slate-300 font-mono">Ctrl + Enter</kbd>
                        <span className="text-slate-700">Gửi tin nhắn AI</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TipsSection;
